module.exports = __webpack_public_path__ + "static/media/Data_insight_1-1.eae585f3.svg";